import React from 'react';
import { string, arrayOf, shape } from 'prop-types';
import NamedLink from '../NamedLink/NamedLink';
import css from './SeoDiscovery.module.css';

const SeoBreadcrumbs = props => {
  const { items } = props;
  if (!items?.length) {
    return null;
  }
  return (
    <nav className={css.breadcrumbs} aria-label="Breadcrumb">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        if (!item.path || isLast) {
          return (
            <span key={item.name}>
              {i > 0 ? ' › ' : null}
              {item.name}
            </span>
          );
        }
        const isDiscovery = item.path.startsWith('/event-discovery');
        return (
          <span key={`${item.name}-${item.path}`}>
            {i > 0 ? ' › ' : null}
            {isDiscovery && item.path === '/event-discovery/' ? (
              <NamedLink name="SearchPage">Event Discovery</NamedLink>
            ) : item.path === '/event-discovery/venues/' ? (
              <NamedLink name="SeoVenuesIndexPage">Venues</NamedLink>
            ) : (
              <a href={item.path}>{item.name}</a>
            )}
          </span>
        );
      })}
    </nav>
  );
};

SeoBreadcrumbs.propTypes = {
  items: arrayOf(
    shape({
      name: string.isRequired,
      path: string,
    })
  ),
};

export default SeoBreadcrumbs;
